import { Component, EventEmitter, Output } from '@angular/core';
import { FileInfo, SelectEvent } from '@progress/kendo-angular-upload';

export interface ImageInfo {
   src: string;
   width: number;
   height: number;
}

@Component({
   selector: 'samweb-upload',
   templateUrl: './upload.component.html',
   styleUrls: ['./upload.component.scss'],
})
export class UploadComponent {
   public uploadSaveUrl = 'saveInlineUrl';
   public uploadRemoveUrl = 'removeInlineUrl';

   @Output() public valueChange: EventEmitter<ImageInfo> = new EventEmitter<ImageInfo>();

   public onSelect(ev: SelectEvent): void {
      ev.files.forEach((file: FileInfo) => {
         if (file.rawFile) {
            const reader = new FileReader();

            reader.onloadend = () => {
               const img = new Image();

               img.src = <string>reader.result;
               img.onload = () => {
                  this.valueChange.emit({
                     src: img.src,
                     height: img.height,
                     width: img.width,
                  });
               };
            };

            reader.readAsDataURL(file.rawFile);
         }
      });
   }

   public onRemove(): void {
      this.valueChange.emit(null);
   }
}
